import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

import CarouselImage1 from "../../../../assets/images/carousel/slide1.jpg";
import CarouselImage2 from "../../../../assets/images/carousel/slide2.jpg";
import CarouselImage3 from "../../../../assets/images/carousel/slide3.jpg";
import CarouselImage4 from "../../../../assets/images/carousel/slide5.jpg";
import CarouselImage5 from "../../../../assets/images/carousel/slide6.jpg";

const ImageCarousel = ({ activeSelection, amountList }) => {
    const findAmountIndex = (amount) => {
        const p = amountList.findIndex((a) => a.amount === amount);
        if (p === -1) {
            return amountList.length;
        }
        return p;
    };

    return (
        <Carousel
            selectedItem={findAmountIndex(activeSelection.amount)}
            showThumbs={false}
            dynamicHeight={false}
            axis="vertical"
        >
            <div>
                <img
                    alt="Infant India"
                    title="Infant India"
                    height="400"
                    src={CarouselImage1}
                />
            </div>
            <div>
                <img
                    alt="Infant India"
                    title="Infant India"
                    height="400"
                    src={CarouselImage2}
                />
            </div>
            <div>
                <img
                    alt="Infant India"
                    title="Infant India"
                    height="400"
                    src={CarouselImage3}
                />
            </div>
            <div>
                <img
                    alt="Infant India"
                    title="Infant India"
                    height="400"
                    src={CarouselImage4}
                />
            </div>
            <div>
                <img
                    alt="Infant India"
                    title="Infant India"
                    height="400"
                    src={CarouselImage5}
                />
            </div>
        </Carousel>
    );
};

export default ImageCarousel;
